import rtk from 'rtk';
import screenfull from 'screenfull';
import { createSelectorHooks } from 'rtk/react';

/*
 * constants
 */
import { name } from './constants';

/* ************************ */

const { createSelectors } = rtk(name);

const selectors = createSelectors({
  // Returns a boolean whether fullscreen is active. (same as screenfull.isFullscree ?)
  is_fullscreen: (state) => state[name].isFullscreen,
  // Returns a boolean whether you are allowed to enter fullscreen.
  fullscreen_enabled: (state) => screenfull.isEnabled,
});

// RTK-AUTOEXPORT
// ---- selectors ---------
export const { selectIsFullscreen, selectFullscreenEnabled } = selectors;
export const { useIsFullscreen, useFullscreenEnabled } =
  createSelectorHooks(selectors);
